module.exports = __webpack_public_path__ + "img/boooks-info-m1.68585946.png";